import { render, staticRenderFns } from "./locations_list.vue?vue&type=template&id=61e43c4d&"
import script from "./locations_list.vue?vue&type=script&lang=js&"
export * from "./locations_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports